// Module
var code = "<p>Enable this setting to include a download link for a PDF that includes responses for particular respondents.</p> <p><strong>Note:</strong> You are normally required to be authenticated to access responses, by enabling this feature anyone with the link can download the file containing your data.</p> ";
// Exports
module.exports = code;